import { FlexCol, FlexRow } from '@/src/components'
import { BaseText } from '@/src/components/BaseText'
import { CloseIconButton } from '@/src/components/CloseIconButton'
import { InformationTooltip } from '@/src/components/InformationTooltip'
import { BaseButton } from '@/src/components/buttons/BaseButton'
import { Box, Input } from '@chakra-ui/react'
import type { ChangeEvent, RefObject } from 'react'
import { useTranslation } from 'react-i18next'
import { FiUpload } from 'react-icons/fi'

interface ReferenceTimePeriodCustomBaseLoadUploadProps {
  customBaseLoadFile: File | null
  fileInputRef: RefObject<HTMLInputElement>
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void
  onRemoveSelectedFile: () => void
}

export const ReferenceTimePeriodCustomBaseLoadUpload = ({
  customBaseLoadFile,
  fileInputRef,
  onFileChange,
  onRemoveSelectedFile,
}: ReferenceTimePeriodCustomBaseLoadUploadProps) => {
  const { t } = useTranslation()

  return (
    <>
      {!customBaseLoadFile ? (
        <BaseText mt='12px' textAlign='center' color='gray.500'>
          {t('components.procurement.forecasting.reference_period_modal.or')}
        </BaseText>
      ) : null}
      <FlexRow mt='12px' alignItems='center' gap='8px'>
        <BaseButton flex='1' variant='secondary' iconLeft={<FiUpload />} onClick={() => fileInputRef.current?.click()}>
          {t('components.procurement.forecasting.reference_period_modal.upload_custom_base_load')}
        </BaseButton>
        <InformationTooltip
          color='gray.500'
          label={
            <FlexCol gap='8px'>
              <Box>{t('components.procurement.forecasting.reference_period_modal.upload_custom_base_load_tooltip')}</Box>
              <Box as='pre' m={0} fontFamily='mono' fontSize='12px' lineHeight='18px' whiteSpace='pre'>
                {t('components.procurement.forecasting.reference_period_modal.upload_custom_base_load_tooltip_example')}
              </Box>
              <Box>{t('components.procurement.forecasting.reference_period_modal.upload_custom_base_load_tooltip_note')}</Box>
            </FlexCol>
          }
        />
      </FlexRow>
      <Input ref={fileInputRef} type='file' accept='.csv,text/csv' hidden onChange={onFileChange} />
      {customBaseLoadFile ? (
        <FlexCol mt='8px' gap='4px' alignItems='center'>
          <FlexRow alignItems='center' justifyContent='center' gap='4px'>
            <BaseText textAlign='center'>
              {t('components.procurement.forecasting.reference_period_modal.selected_csv_file', {
                fileName: customBaseLoadFile.name,
              })}
            </BaseText>
            <CloseIconButton
              aria-label={t('components.procurement.forecasting.reference_period_modal.remove_selected_file')}
              onClick={onRemoveSelectedFile}
            />
          </FlexRow>
        </FlexCol>
      ) : null}
    </>
  )
}
